import { OrderStatus } from "../enums/OrderStatuses";
import { orderServiceUrl } from '../config/config';

const createUpdateOrder = async (newOrder, authorizationToken) => {
    try {
      const response = await fetch(`${orderServiceUrl}/order`, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
        },
        body: JSON.stringify(newOrder)
      });
      if (!response.ok) {
        throw new Error('Request failed');
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw new Error(error.message);
    }
  };

const acceptOrder = async (newOrder, authorizationToken) => {
    try {
      const response = await fetch(`${orderServiceUrl}/order/accepted`, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
        },
        body: JSON.stringify(newOrder)
      });
      if (!response.ok) {
        throw new Error('Request failed');
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw new Error(error.message);
    }
  };

const getOrders = async (searchParams, authorizationToken) => {
      try {
        const response = await fetch(`${orderServiceUrl}/order/${searchParams.criteria}/${searchParams.id}`, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
          }
        });
        if (!response.ok) {
          throw new Error('Request failed');
        }
        const responseData = await response.json();
        return responseData;
      } catch (error) {
        throw new Error(error.message);
      }
    };

const getKitchenBalance = async (kitchenId, authorizationToken) => {
      try {
        const response = await fetch(`${orderServiceUrl}/order/kitchen/balance/${kitchenId}`, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
          }
        });
        if (!response.ok) {
          throw new Error('Request failed');
        }
        const responseData = await response.json();
        return responseData;
      } catch (error) {
        throw new Error(error.message);
      }
};
  
export { createUpdateOrder, acceptOrder, getOrders, getKitchenBalance };